import Vue from "vue";
import App from "./App.vue";

import "@/components/globalComponents";
import "@/packages.js";
import "@/filters.js";
import "@/mixins.js";
import router from "@/router";
import store from "@/store";
import wb from "./registerServiceWorker";
Vue.prototype.$workbox = wb;
Vue.config.productionTip = false;
import i18n from "./plugins/i18n";

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

window.App = app;
